import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  html, body, #root {
    min-height: 100vh;
    font-family: 'Poppins', sans-serif;
  }

  html {
    scroll-behavior: smooth;
  }

  /* #root {
    background-color: #FCF2EA;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
  } */

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  
  
`
